import React from 'react'
import { TextAreaStyle } from './style'
import { TextAreaProps } from '../../types/components/textArea'

export const TextArea: TextAreaProps = ({
  label,
  onFocus,
  onBlur,
  onChange,
  value,
  disabled,
  placeholder,
  isValidate = true,
  widthDiv = '100%'
}) => {
  return (
    <TextAreaStyle isValidate={isValidate} widthDiv={widthDiv}>
      <label>{label}</label>
      <textarea
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
      />
    </TextAreaStyle>
  )
}
